export default __webpack_public_path__ + "static/right-icon-4387edf51321fb836ca50cdc0bd7fe6d.png";